"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shareReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var ShareAction_1 = require("@/pages/common/actions/ShareAction");
var ShareState_init_1 = require("@/pages/common/states/ShareState.init");
exports.shareReducer = function (state, action) {
    if (state === void 0) { state = ShareState_init_1.defaultShareState; }
    switch (action.type) {
        case typesafe_actions_1.getType(ShareAction_1.default.setShareActive):
            return __assign(__assign({}, state), { isActive: action.payload });
    }
    return state;
};
